module.exports = __webpack_public_path__ + "assets/img/mask_group.e2a38970.svg";